import {Select} from "antd";
import React, {useEffect, useState} from "react";
import { getProvince} from "../../../pages/api/hello";

interface IProps {
    value: string|number,
    onChange: Function|any,
    error: string|null|any,
    textLabel: string|any,
}

const Province: React.FC<IProps> = ({ value, error, onChange, textLabel }) => {
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState <any>([]);

    useEffect(() => {
        let opt = [...options];
        if(!opt.find((item) => item.id == value)) {
            opt.push({
                id: value,
                value: value,
                name: textLabel,
                label: textLabel
            })
            setOptions(opt)
        }

    }, [value])

    const fetchData = async () => {
        await setLoading(true)
        const res : any = await getProvince('');

        await setOptions(res?.results ?? [])
        await setLoading(false)
    }

    return (
        <div className="box-info p-4 rounded-lg h-full">
            <div className="bold">Tỉnh/Thành phố</div>
            <div className="flex gap-2 flex-col mt-1">
                <Select
                    placeholder="Chọn tỉnh/thành phố"
                    value={ value }
                    style={{ width: '100%' }}
                    loading={loading}
                    options={options}
                    fieldNames={{ label: 'name', value: 'id' }}
                    onFocus={fetchData}
                    onChange={onChange}
                />
                { error && <span className="color-danger">{ error }</span> }
            </div>
        </div>
    )
}

export default Province;
